import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: 'Bearer ' + token() });
const NAVY = '#1A3A5C';
const ORANGE = '#EA6F2E';

function Toast({ message, onDone }) {
  useEffect(() => { const t = setTimeout(onDone, 3000); return () => clearTimeout(t); }, []);
  return (
    <div style={{ position:'fixed', bottom:'32px', left:'50%', transform:'translateX(-50%)', zIndex:9999, background:'#111827', color:'#fff', padding:'13px 24px', borderRadius:'10px', boxShadow:'0 8px 32px rgba(0,0,0,0.3)', fontSize:'13px', fontWeight:'500' }}>
      {message}
    </div>
  );
}

function CreatePositionModal({ onClose, onSave }) {
  const [form, setForm] = useState({
    position_title: '',
    department: '',
    description: ''
  });
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(f => ({...f, [k]: v}));
  const inputStyle = { width:'100%', padding:'9px 11px', border:'1px solid #E5E7EB', borderRadius:'6px', fontSize:'13px', outline:'none' };
  const labelStyle = { display:'block', fontSize:'11px', fontWeight:'600', color:'#6B7280', marginBottom:'5px', textTransform:'uppercase', letterSpacing:'0.04em' };

  const handleSave = async () => {
    if (!form.position_title || !form.department) {
      alert('Position title and department are required');
      return;
    }
    setSaving(true);
    try {
      await onSave(form);
      onClose();
    } catch (e) {
      alert('Failed to create position: ' + (e.response?.data?.error || e.message));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:'#fff', borderRadius:'12px', padding:'28px', width:'600px', maxWidth:'90vw', maxHeight:'90vh', overflowY:'auto' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px' }}>
          <h2 style={{ fontSize:'18px', fontWeight:'700', color:'#111827', margin:0 }}>
            Create New Position Opening
          </h2>
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:'#9CA3AF', fontSize:'22px' }}>×</button>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr', gap:'16px', marginBottom:'20px' }}>
          <div>
            <label style={labelStyle}>Position Title *</label>
            <input type="text" value={form.position_title} onChange={e => set('position_title', e.target.value)} style={inputStyle} placeholder="e.g., Curator of Collections" />
          </div>
          
          <div>
            <label style={labelStyle}>Department *</label>
            <select value={form.department} onChange={e => set('department', e.target.value)} style={inputStyle}>
              <option value="">Select Department</option>
              <option value="EXECUTIVE">Executive</option>
              <option value="COLLECTIONS">Collections</option>
              <option value="PUBLIC ENGAGEMENT">Public Engagement</option>
              <option value="ADMINISTRATION">Administration</option>
              <option value="EXHIBITIONS">Exhibitions</option>
            </select>
          </div>

          <div>
            <label style={labelStyle}>Position Description</label>
            <textarea value={form.description} onChange={e => set('description', e.target.value)} style={{...inputStyle, minHeight:'120px', fontFamily:'inherit'}} placeholder="Describe the role, responsibilities, and qualifications..." />
          </div>
        </div>

        <div style={{ display:'flex', justifyContent:'flex-end', gap:'8px' }}>
          <button onClick={onClose} style={{ padding:'8px 18px', border:'1px solid #E5E7EB', background:'#fff', borderRadius:'7px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>Cancel</button>
          <button onClick={handleSave} disabled={saving} style={{ padding:'8px 18px', border:'none', background: ORANGE, color:'#fff', borderRadius:'7px', fontSize:'13px', fontWeight:'600', cursor:'pointer', opacity: saving ? 0.5 : 1 }}>
            {saving ? 'Creating...' : 'Create Position'}
          </button>
        </div>
      </div>
    </div>
  );
}

function AwardPositionModal({ position, onClose, onAward }) {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    personal_email: '',
    phone: '',
    start_date: ''
  });
  const [awarding, setAwarding] = useState(false);

  const set = (k, v) => setForm(f => ({...f, [k]: v}));
  const inputStyle = { width:'100%', padding:'9px 11px', border:'1px solid #E5E7EB', borderRadius:'6px', fontSize:'13px', outline:'none' };
  const labelStyle = { display:'block', fontSize:'11px', fontWeight:'600', color:'#6B7280', marginBottom:'5px', textTransform:'uppercase', letterSpacing:'0.04em' };

  const handleAward = async () => {
    if (!form.first_name || !form.last_name || !form.personal_email || !form.start_date) {
      alert('All fields except phone are required');
      return;
    }
    setAwarding(true);
    try {
      await onAward(position.id, form);
      onClose();
    } catch (e) {
      alert('Failed to award position: ' + (e.response?.data?.error || e.message));
    } finally {
      setAwarding(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ background:'#fff', borderRadius:'12px', padding:'28px', width:'600px', maxWidth:'90vw', maxHeight:'90vh', overflowY:'auto' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px' }}>
          <div>
            <h2 style={{ fontSize:'18px', fontWeight:'700', color:'#111827', margin:0, marginBottom:'4px' }}>
              Award Position
            </h2>
            <p style={{ fontSize:'13px', color:'#6B7280', margin:0 }}>
              {position.position_title} - {position.department}
            </p>
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:'#9CA3AF', fontSize:'22px' }}>×</button>
        </div>

        <div style={{ background:'#FEF3C7', padding:'12px', borderRadius:'8px', marginBottom:'20px', border:'1px solid #FDE68A' }}>
          <p style={{ fontSize:'12px', color:'#92400E', margin:0 }}>
            💡 This will create an onboarding case for the selected candidate and mark this position as awarded.
          </p>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'16px', marginBottom:'20px' }}>
          <div>
            <label style={labelStyle}>First Name *</label>
            <input type="text" value={form.first_name} onChange={e => set('first_name', e.target.value)} style={inputStyle} />
          </div>
          
          <div>
            <label style={labelStyle}>Last Name *</label>
            <input type="text" value={form.last_name} onChange={e => set('last_name', e.target.value)} style={inputStyle} />
          </div>

          <div style={{ gridColumn:'1 / -1' }}>
            <label style={labelStyle}>Personal Email *</label>
            <input type="email" value={form.personal_email} onChange={e => set('personal_email', e.target.value)} style={inputStyle} placeholder="candidate@email.com" />
          </div>

          <div>
            <label style={labelStyle}>Phone</label>
            <input type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} style={inputStyle} placeholder="(555) 123-4567" />
          </div>

          <div>
            <label style={labelStyle}>Start Date *</label>
            <input type="date" value={form.start_date} onChange={e => set('start_date', e.target.value)} style={inputStyle} />
          </div>
        </div>

        <div style={{ display:'flex', justifyContent:'flex-end', gap:'8px' }}>
          <button onClick={onClose} style={{ padding:'8px 18px', border:'1px solid #E5E7EB', background:'#fff', borderRadius:'7px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>Cancel</button>
          <button onClick={handleAward} disabled={awarding} style={{ padding:'8px 18px', border:'none', background: ORANGE, color:'#fff', borderRadius:'7px', fontSize:'13px', fontWeight:'600', cursor:'pointer', opacity: awarding ? 0.5 : 1 }}>
            {awarding ? 'Awarding...' : 'Award Position & Create Onboarding'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function PositionOpening_NEW({ isAdmin, currentUser }) {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [awardingPosition, setAwardingPosition] = useState(null);
  const [toast, setToast] = useState(null);
  const [filter, setFilter] = useState('open'); // 'open' or 'awarded'

  useEffect(() => {
    fetchPositions();
  }, []);

  const fetchPositions = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API + '/position-openings', { headers: headers() });
      setPositions(res.data);
    } catch (e) {
      console.error(e);
      setToast('Failed to load positions');
    } finally {
      setLoading(false);
    }
  };

  const handleCreatePosition = async (data) => {
    await axios.post(API + '/position-openings', data, { headers: headers() });
    setToast('Position created!');
    fetchPositions();
  };

  const handleAwardPosition = async (positionId, candidateData) => {
    await axios.post(API + '/position-openings/' + positionId + '/award', candidateData, { headers: headers() });
    setToast('Position awarded! Onboarding case created.');
    fetchPositions();
  };

  const handleDeletePosition = async (position) => {
    if (!window.confirm(`Are you sure you want to delete the ${position.position_title} position?`)) return;
    try {
      await axios.delete(API + '/position-openings/' + position.id, { headers: headers() });
      setToast('Position deleted');
      fetchPositions();
    } catch (e) {
      alert('Failed to delete: ' + (e.response?.data?.error || e.message));
    }
  };

  const filteredPositions = positions.filter(p => 
    filter === 'open' ? p.status === 'open' : p.status === 'awarded'
  );

  if (loading) return <div style={{ padding:'40px', textAlign:'center', color:'#9CA3AF' }}>Loading positions...</div>;

  return (
    <div style={{ padding:'24px 28px' }}>
      {toast && <Toast message={toast} onDone={() => setToast(null)} />}
      {showCreateModal && (
        <CreatePositionModal 
          onClose={() => setShowCreateModal(false)}
          onSave={handleCreatePosition}
        />
      )}
      {awardingPosition && (
        <AwardPositionModal 
          position={awardingPosition}
          onClose={() => setAwardingPosition(null)}
          onAward={handleAwardPosition}
        />
      )}

      <div style={{ background:'#fff', padding:'20px 24px', borderRadius:'14px', marginBottom:'20px', boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
          <div>
            <h2 style={{ fontSize:'20px', fontWeight:'600', color: NAVY, margin:0, marginBottom:'4px' }}>
              Position Openings
            </h2>
            <p style={{ fontSize:'12px', color:'#6B7280', margin:0 }}>
              Manage job openings and award positions to candidates
            </p>
          </div>
          <button 
            onClick={() => setShowCreateModal(true)}
            style={{
              display:'flex', alignItems:'center', gap:'6px', padding:'9px 16px',
              background: ORANGE, color:'#fff', border:'none', borderRadius:'8px',
              fontSize:'13px', fontWeight:'600', cursor:'pointer', transition:'all 0.2s'
            }}
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"/>
            </svg>
            Create Position
          </button>
        </div>

        {/* Filter tabs */}
        <div style={{ display:'flex', gap:'8px', borderBottom:'2px solid #E5E7EB' }}>
          <button
            onClick={() => setFilter('open')}
            style={{
              padding:'8px 16px', background:'none', border:'none', borderBottom: filter === 'open' ? `3px solid ${ORANGE}` : '3px solid transparent',
              marginBottom:'-2px', cursor:'pointer', fontSize:'13px', fontWeight:'600',
              color: filter === 'open' ? NAVY : '#6B7280'
            }}
          >
            Open Positions ({positions.filter(p => p.status === 'open').length})
          </button>
          <button
            onClick={() => setFilter('awarded')}
            style={{
              padding:'8px 16px', background:'none', border:'none', borderBottom: filter === 'awarded' ? `3px solid ${ORANGE}` : '3px solid transparent',
              marginBottom:'-2px', cursor:'pointer', fontSize:'13px', fontWeight:'600',
              color: filter === 'awarded' ? NAVY : '#6B7280'
            }}
          >
            Awarded ({positions.filter(p => p.status === 'awarded').length})
          </button>
        </div>
      </div>

      {/* Position cards */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(320px, 1fr))', gap:'16px' }}>
        {filteredPositions.map(position => (
          <div key={position.id} style={{ 
            background:'#fff', 
            border:'1px solid #E5E7EB', 
            borderRadius:'10px', 
            padding:'20px',
            boxShadow:'0 1px 3px rgba(0,0,0,0.08)',
            transition:'all 0.2s'
          }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'start', marginBottom:'12px' }}>
              <div style={{ flex:1 }}>
                <h3 style={{ fontSize:'16px', fontWeight:'600', color: NAVY, margin:0, marginBottom:'4px' }}>
                  {position.position_title}
                </h3>
                <p style={{ fontSize:'12px', color: ORANGE, fontWeight:'600', margin:0 }}>
                  {position.department}
                </p>
              </div>
              {isAdmin && position.status === 'open' && (
                <button 
                  onClick={() => handleDeletePosition(position)}
                  style={{ 
                    width:'28px', height:'28px', borderRadius:'6px', border:'none', 
                    background:'#FEE2E2', cursor:'pointer', display:'flex', 
                    alignItems:'center', justifyContent:'center'
                  }}
                  title="Delete"
                >
                  <svg width="14" height="14" fill="none" stroke="#991B1B" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              )}
            </div>

            {position.description && (
              <p style={{ fontSize:'12px', color:'#374151', margin:'0 0 12px 0', lineHeight:'1.5' }}>
                {position.description.length > 150 ? position.description.substring(0, 150) + '...' : position.description}
              </p>
            )}

            <div style={{ borderTop:'1px solid #E5E7EB', paddingTop:'12px', marginTop:'12px' }}>
              {position.status === 'open' && (
                <>
                  <p style={{ fontSize:'11px', color:'#6B7280', margin:'0 0 12px 0' }}>
                    Posted: {new Date(position.created_at).toLocaleDateString()}
                  </p>
                  <button 
                    onClick={() => setAwardingPosition(position)}
                    style={{
                      width:'100%', padding:'8px 14px', background: ORANGE, color:'#fff',
                      border:'none', borderRadius:'7px', fontSize:'13px', fontWeight:'600',
                      cursor:'pointer', transition:'all 0.2s'
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#D85F1E'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = ORANGE; }}
                  >
                    Award Position
                  </button>
                </>
              )}

              {position.status === 'awarded' && (
                <div style={{ background:'#F0FDF4', padding:'12px', borderRadius:'6px', border:'1px solid #86EFAC' }}>
                  <p style={{ fontSize:'12px', color:'#166534', fontWeight:'600', margin:'0 0 4px 0' }}>
                    ✅ Awarded to: {position.awarded_candidate_name}
                  </p>
                  <p style={{ fontSize:'11px', color:'#6B7280', margin:0 }}>
                    Start Date: {new Date(position.awarded_start_date).toLocaleDateString()}
                  </p>
                </div>
              )}
            </div>
          </div>
        ))}

        {filteredPositions.length === 0 && (
          <div style={{ 
            gridColumn:'1 / -1', 
            textAlign:'center', 
            padding:'60px 20px',
            background:'#fff',
            borderRadius:'12px',
            border:'1px solid #E5E7EB'
          }}>
            <svg width="64" height="64" fill="none" stroke="#D1D5DB" viewBox="0 0 24 24" style={{ margin:'0 auto 16px' }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
            </svg>
            <p style={{ fontSize:'14px', fontWeight:'600', color:'#6B7280', marginBottom:'8px' }}>
              {filter === 'open' ? 'No open positions' : 'No awarded positions yet'}
            </p>
            <p style={{ fontSize:'12px', color:'#9CA3AF', marginBottom:'16px' }}>
              {filter === 'open' ? 'Create a new position opening to get started' : 'Award an open position to see it here'}
            </p>
            {filter === 'open' && (
              <button 
                onClick={() => setShowCreateModal(true)}
                style={{
                  padding:'10px 20px', background: ORANGE, color:'#fff',
                  border:'none', borderRadius:'8px', fontSize:'14px', fontWeight:'600',
                  cursor:'pointer'
                }}
              >
                Create First Position
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
